import axios from "axios";
import React, { useEffect, useState } from "react";
import ReactTooltip from "react-tooltip";
import { UserConsumer } from "../../../UserContext";
import Header from "../../../components/Header";
import FilterationBar from "./FilterationBar";
import {
	tableStyle,
	dateCol,
} from "../../ticketModule/variables/ListingVariables";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { Table } from "../../../components/CustomPaginations";
import { CalendarHolidays_API } from "./CalendarHolidays_API";
import SubHeader from "../../../components/SubHeader";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Redirect } from "react-router-dom";
import { Routes } from "../../../configurations/config";
import { Button } from "reactstrap";
import { AlertPopups } from "../../../components/AlertPopups";

function CalendarHolidays() {
	let token = null;
	const getColumns = [
		{
			dataField: "startDate",
			text: "Start Date",
			sort: true,
			formatter: dateCol,
		},
		{
			dataField: "endDate",
			text: "End Date",
			sort: true,
			formatter: dateCol,
		},
		{
			dataField: "duration",
			text: "Duration",
			sort: true,
		},
		{
			dataField: "description",
			text: "Description",
			sort: true,
			formatter: (value) => {
				return (
					<span data-tip={value}>
						{value.length > 50 ? value.substring(0, 50) + "..." : value}
						<ReactTooltip place="top" type="dark" effect="solid" />
					</span>
				);
			},
		},
		{
			dataField: "holidayId",
			text: "Actions",
			formatter: (cell, row) => (
				<Button
					color="danger"
					size="sm"
					onClick={() => handleDelete(cell)}
					disabled={deletingId === cell}
				>
					{deletingId === cell ? "Deleting..." : "Delete"}
				</Button>
			),
		},
	];
	const [sortBy, setSortBy] = useState({
		dataField: "startDate",
		order: "asc",
	});
	const defaultSorted = [
		{
			dataField: "startDate",
			order: "asc",
		},
	];
	const PageSize = 10;
	const date = new Date();
	const currentYear = date.getFullYear();
	const [selectedYear, setSelectedYear] = useState({
		value: currentYear,
		label: currentYear,
	});

	const [yearsList, setYearsList] = useState([]);
	const [pageNum, setPageNum] = useState(1);
	const [apiTokenHeader, setApiTokenHeader] = useState(null);
	const [calendarHolidaysData, setCalendarHolidaysData] = useState([]);
	const [pagerData, setPagerData] = useState([]);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(10);
	const [isLoading, setIsLoading] = useState(true);
	const [deletingId, setDeletingId] = useState(null);

	useEffect(() => {
		//To auto start from company date(2006) till current year
		let startYear = 2006;
		const list = [];
		do {
			list.unshift({ value: startYear, label: startYear.toString() });
			startYear++;
		} while (startYear != currentYear + 1);
		setYearsList(list);

		const headers = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(
				`${CalendarHolidays_API.GetCalendarHolidaysbyPagination}?Year=${currentYear}&PageNumber=${pageNum}&PageSize=${PageSize}&SortBy=${sortBy.dataField}_${sortBy.order}`,
				{ headers: headers }
			)
			.then(({ status, data, headers }) => {
				if (status === 200) {
					setIsLoading(false);
					setCalendarHolidaysData(data.calendarHolidays);
					setPagerData(JSON.parse(headers["x-pagination"]));
				}
			});
		setApiTokenHeader(headers);
	}, []);

	const onYearChange = (year) => {
		//function called on year filteration
		setIsLoading(true);
		setSelectedYear(year);

		axios
			.get(
				`${CalendarHolidays_API.GetCalendarHolidaysbyPagination}?Year=${year.value}&PageNumber=${pageNum}&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}`,
				{ headers: apiTokenHeader }
			)
			.then(({ status, data, headers }) => {
				if (status === 200) {
					setIsLoading(false);
					setCalendarHolidaysData(data.calendarHolidays);
					setPagerData(JSON.parse(headers["x-pagination"]));
				}
			});
	};

	const receiveData = (PageSize) => {
		//function called on pagination dropdown
		setIsLoading(true);
		axios
			.get(
				`${CalendarHolidays_API.GetCalendarHolidaysbyPagination}?Year=${
					selectedYear.value
				}&PageNumber=${1}&PageSize=${PageSize}&SortBy=${
					sortBy.dataField
				}_${sortBy.order}`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setPageNum(1);
					setIsLoading(false);
					setNumberOfItemsPerPage(PageSize);
					setCalendarHolidaysData(res.data.calendarHolidays);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
				}
			});
	};

	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		setIsLoading(true);
		let getData = false;
		let apiURL = "";

		//function called on table sorting and pagination
		if (type === "sort") {
			apiURL = `${CalendarHolidays_API.GetCalendarHolidaysbyPagination}?Year=${selectedYear.value}&PageNumber=${page}&PageSize=${numberOfItemsPerPage}&SortBy=${sortField}_${sortOrder}`;
			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${CalendarHolidays_API.GetCalendarHolidaysbyPagination}?Year=${selectedYear.value}&PageNumber=${page}&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}`;
			getData = true;
		}
		if (getData) {
			axios
				.get(apiURL, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				.then((res) => {
					if (res.status === 200) {
						setPageNum(page);
						setIsLoading(false);
						setCalendarHolidaysData(res.data.calendarHolidays);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
					}
				});
		}
	};

	const handleDelete = (id) => {
		debugger;
		// Use modal confirmBox for confirmation (consistent with other pages)
		AlertPopups.confirmBox
			.fire({
				text: "Do you want to Delete Calendar Holiday?",
			})
			.then((result) => {
				if (result.value || result.isConfirmed) {
					setDeletingId(id);
					axios
						.delete(`${CalendarHolidays_API.DeleteCalendarHoliday}/${id}`, {
							headers: { Authorization: `Bearer ${token}` },
						})
						.then(({ status }) => {
							if (status === 200 || status === 204) {
								AlertPopups.successAlert.fire({
									text: "Holiday deleted successfully",
								});
								// Refresh data for current year
								onYearChange(selectedYear);
							} else {
								AlertPopups.ErrorAlert.fire({
									text: "Holiday Deletion Error",
								});
							}
						})
						.catch((error) => {
							AlertPopups.ErrorAlert.fire({
								text: "Error deleting holiday",
							});
						})
						.finally(() => {
							setDeletingId(null);
						});
				}
			});
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return userDetails.empRole.includes("3") ? ( //authorization
					<>
						<div className="container-fluid pl-2 pr-2">
							<Header
								title="Calendar Holidays"
								headerBorder="false"
							/>

							<SubHeader
								btnTitle="Create New"
								icon={faPlus}
								linkTo={Routes.AddNewHoliday}
							/>

							<FilterationBar
								years={yearsList}
								selectedYear={selectedYear}
								onYearChange={(year) => onYearChange(year)}
							/>

							{/*Table with pagination */}
							<PaginationProvider
								pagination={paginationFactory({
									custom: true,
									totalSize: pagerData
										? pagerData.TotalCount
										: 0,
									page: pageNum,
									sizePerPage: numberOfItemsPerPage,
									paginationSize: numberOfItemsPerPage,
								})}
							>
								{({
									paginationProps,
									paginationTableProps,
								}) => {
									return (
										<Table
											inputValue={""}
										keyField={"holidayId"}
											classes={"description"}
											columns={getColumns}
											items={calendarHolidaysData}
											tableStyle={tableStyle}
											paginationProps={paginationProps}
											paginationTableProps={
												paginationTableProps
											}
											onTablePageChange={
												handleTableChange
											}
											defaultSorted={defaultSorted}
											showFeedback={true}
											tableLoader={isLoading}
											loading={isLoading}
											pagerData={pagerData}
											SearchBar={() => {
												return null;
											}}
											receiveData={(PageSize) => {
												receiveData(PageSize);
											}}
										/>
									);
								}}
							</PaginationProvider>
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" /> //redirection to unauthorized users
				);
			}}
		</UserConsumer>
	);
}

export default CalendarHolidays;
